/**
 * HOR Featured Products — rotating product tiles
 * ---------------------------------------------------------------
 * On each page load, replaces the server-rendered tiles inside every
 * .hor-products section (sections/hor-featured-products.liquid) with a
 * random selection of products pulled live from that section's
 * collection — the same "fresh on every visit" behaviour as the
 * Shop by room tiles (hor-shop-by-room-randomizer.js).
 *
 * The collection handle is read from the section's "Shop all" link href
 * (e.g. /collections/lighting). Products are shuffled client-side and
 * only available products fill the grid first.
 *
 * Include on the page with:
 *   <script src="{{ 'hor-featured-products-rotator.js' | asset_url }}" defer></script>
 */
(function () {
  'use strict';

  var ROOT_SELECTOR = '.hor-products';
  var TILE_SELECTOR = '.hor-product-tile';
  var LINK_SELECTOR = '.hor-text-link';

  // Per-pageview cache so we only fetch each collection once even if
  // init() runs again (e.g. after an InstantClick navigation).
  var cache = {};

  function getCollectionHandle(href) {
    if (!href) return null;
    var match = href.match(/\/collections\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function shuffle(list) {
    var arr = list.slice();
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = arr[i];
      arr[i] = arr[j];
      arr[j] = tmp;
    }
    return arr;
  }

  function moneyString(price) {
    // products.json returns prices as decimal dollar strings, e.g. "158.00".
    // Format with thousands separators, preserving two decimals.
    var dollars = parseFloat(price);
    if (isNaN(dollars)) return null;
    return (
      '$' +
      dollars.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    );
  }

  function buildTile(product, index) {
    var imgSrc =
      (product.images && product.images[0] && product.images[0].src) ||
      (product.image && product.image.src);
    if (!imgSrc) return null;

    // Bump to a reasonable tile size (products.json gives small thumbs by default).
    imgSrc = imgSrc.replace(/_(\d+x\d*|x\d+|small|compact|medium|large|grande)\./i, '_600x600.');

    var href = '/collections/' + product.handle_collection + '/products/' + product.handle;
    if (product.url) href = product.url;

    var badge = '';
    var tags = product.tags || [];
    var tagString = tags.join(' ').toLowerCase();
    if (tagString.indexOf('vintage') !== -1) badge = 'Vintage';
    else if (tagString.indexOf('rare') !== -1) badge = 'Rare';
    else if (tagString.indexOf('iconic') !== -1) badge = 'Iconic';
    else if (product.available === false) badge = 'Sold';

    var price = moneyString(product.variants && product.variants[0] && product.variants[0].price);
    var priceText = price ? '<span class="money">' + price + '</span>' : 'Inquire for pricing';

    var badgeHtml = badge ? '<span class="hor-product-badge">' + badge + '</span>' : '';

    var tile = document.createElement('a');
    tile.className = 'hor-product-tile';
    tile.href = href;
    tile.innerHTML =
      '<div class="hor-product-img">' +
      '<img src="' + imgSrc + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" loading="lazy" />' +
      badgeHtml +
      '</div>' +
      '<div class="hor-product-info">' +
      '<div class="hor-product-brand">' + (product.vendor || '') + '</div>' +
      '<div class="hor-product-name">' + (product.title || '') + '</div>' +
      '<div class="hor-product-price">' + priceText + '</div>' +
      '</div>';
    return tile;
  }

  function rotateSection(root) {
    var link = root.querySelector(LINK_SELECTOR);
    if (!link) return;
    var handle = getCollectionHandle(link.getAttribute('href'));
    if (!handle) return;

    var tiles = root.querySelectorAll(TILE_SELECTOR);
    if (!tiles.length) return;

    function render(products) {
      // Prefer available products, then fill remaining slots with any.
      var available = products.filter(function (p) { return p.available !== false; });
      var pool = shuffle(available).concat(shuffle(products.filter(function (p) { return p.available === false; })));

      var container = root.querySelector('.hor-product-grid');
      if (!container) return;

      var frag = document.createDocumentFragment();
      var count = 0;
      for (var i = 0; i < pool.length && count < tiles.length; i++) {
        var tile = buildTile(pool[i], count);
        if (tile) {
          frag.appendChild(tile);
          count++;
        }
      }
      // Only swap when we actually built a full row set; otherwise keep
      // the server-rendered tiles (safer than a partially-filled grid).
      if (count >= tiles.length) {
        container.innerHTML = '';
        container.appendChild(frag);
      }
    }

    if (cache[handle]) {
      render(cache[handle]);
      return;
    }

    fetch('/collections/' + handle + '/products.json?limit=100')
      .then(function (res) {
        return res.ok ? res.json() : Promise.reject(res.status);
      })
      .then(function (data) {
        cache[handle] = data.products || [];
        render(cache[handle]);
      })
      .catch(function () {
        // Network/API hiccup: keep the server-rendered tiles in place.
        cache[handle] = cache[handle] || [];
      });
  }

  function init() {
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i++) {
      rotateSection(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // This theme navigates via InstantClick (see layout/theme.liquid), which
  // swaps page content without a full reload. Re-run after each swap so the
  // grids still re-randomize on "every page load" from the shopper's POV.
  if (window.InstantClick && typeof window.InstantClick.on === 'function') {
    window.InstantClick.on('change', init);
  }
})();